if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.subscriptionRadios = this.querySelectorAll('.subscription-radio');
        this.submitButton = this.querySelector('[type="submit"]');
        this.originalPrice = this.querySelector('.original-price');
        this.actaulPrice = this.querySelector('.actaul-price');
        this.subscriptionTag = this.querySelector('.subscription-tag');
        this.renewText = this.querySelector('.renew-text');

        if (this.subscriptionRadios?.length > 0) {
          this.initPrices();
        }
        this.subscriptionRadios.forEach((subscriptionRadio) => {
          subscriptionRadio.addEventListener('change', this.handleChange.bind(this));
        });
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      handleChange(event) {
        // console.log('🚀 ~ ProductInfo ~ handleChange ~ event:', event);
        if (event.target.dataset.subscriptionPrice === '$0') {
          this.originalPrice.innerHTML = event.target.dataset.originalPrice;
          this.actaulPrice.classList.add('tw-hidden');
          this.subscriptionTag.classList.add('tw-hidden');
          this.originalPrice.classList.remove('tw-text-ada-blue');
          this.originalPrice.classList.remove('tw-line-through');
        } else {
          this.actaulPrice.classList.remove('tw-hidden');
          this.subscriptionTag.classList.remove('tw-hidden');
          this.originalPrice.classList.add('tw-text-ada-blue');
          this.originalPrice.classList.add('tw-line-through');
          this.originalPrice.innerHTML = event.target.dataset.originalPrice;
          this.actaulPrice.innerHTML = event.target.dataset.subscriptionPrice;
          this.subscriptionTag.innerHTML = event.target.dataset.percentageSavings;
        }
        if (event.target.dataset.renewText) {
          this.renewText.innerHTML = event.target.dataset.renewText;
        }
      }

      initPrices() {
        this.subscriptionRadios.forEach((subscriptionRadio) => {
          // console.log('🚀 ~ ProductInfo ~ this.subscriptionRadios.forEach ~ subscriptionRadio:', subscriptionRadio);
          if (subscriptionRadio.checked) {
            if (subscriptionRadio.dataset.subscriptionPrice === '$0') {
              this.originalPrice.classList.remove('tw-text-ada-blue');
              this.originalPrice.classList.remove('tw-line-through');
              this.originalPrice.innerHTML = subscriptionRadio.dataset.originalPrice;
              this.actaulPrice.classList.add('tw-hidden');
              this.subscriptionTag.classList.add('tw-hidden');
            } else {
              this.actaulPrice.classList.remove('tw-hidden');
              this.subscriptionTag.classList.remove('tw-hidden');
              this.originalPrice.classList.add('tw-text-ada-blue');
              this.originalPrice.classList.add('tw-line-through');
              this.originalPrice.innerHTML = subscriptionRadio.dataset.originalPrice;
              this.actaulPrice.innerHTML = subscriptionRadio.dataset.subscriptionPrice;
              this.subscriptionTag.innerHTML = subscriptionRadio.dataset.percentageSavings;
            }
            if (subscriptionRadio.dataset.renewText) {
              this.renewText.innerHTML = subscriptionRadio.dataset.renewText;
            }
          }
        });
      }

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
